<template>
  <div v-if="clientRefNo" class="membership">
    <div class="columns">
      <section  class="column">
        
        <article class="season-card card">
          <div class="card__header">
            <h3 class="season-card__heading"><span>Stoke</span> City <br>Football <span>Club</span></h3>
          </div>
          <div class="card__footer">
            <p class="season-card__subheading">{{clientRefNo}}</p>
          </div>
        </article>
      </section>

      <section class="column">
        <article class="teamcard card">
          <div class="card__header">
            <h3 class="teamcard__heading"><span>Card</span> Balance</h3>
            <p class="teamcard__points">{{teamCardBalance}} pts</p>
            <p>If you wish to spend your TeamCard points on the Official Stoke City Store website, please enter your TeamCard reference number into the <a href="https://store.stokecityfc.com/teamcard/settings/" target="_blank">TeamCard page</a> on the online store.</p>
          </div>

          <div class="card__footer">
          </div>
        </article>
      </section>
      <p class="team-card-help">If you wish to spend your TeamCard points on the Official Stoke City Store website, please enter your TeamCard reference number into the <a href="https://store.stokecityfc.com/teamcard/settings/" target="_blank">TeamCard page</a> on the online store.</p> 
    </div>

    <section class="wide-section">
      <h2 class="heading-2 align-left">Your Next Ticket</h2>

      <article class="next-ticket" v-if="nextGame">
        <time class="next-ticket__info">
          <span class="next-ticket__time">{{ nextGame.date | moment('HH:mm') }}</span>
          <span class="next-ticket__date">{{ nextGame.date | moment('DD MMMM YYYY') }}</span>
        </time>
        <h3 class="next-ticket__main">{{ nextGame.name }}</h3>
        <a href="https://www.scfcdirect.com/events.aspx" target="_blank" class="next-ticket__buy">Buy More Tickets</a>
      </article>

      <article class="next-ticket" v-else>
        <h3 class="next-ticket__main">You currently have no upcoming tickets</h3>
        <a href="https://www.scfcdirect.com/events.aspx" target="_blank" class="next-ticket__buy">Buy More Tickets</a>
      </article>

    </section>

    <section class="wide-section">
      <h2 class="heading-2 align-left">Ticket History</h2>

      <table class="table">
        <thead>
          <th class="table__heading table__heading--date">Date</th>
          <th class="table__heading table__heading--extra table__heading--center">Kick Off</th>
          <th class="table__heading table__heading--extra table__heading--center">Stadium Entry</th>
          <th class="table__heading">Match</th>
          <th class="table__heading table__heading--extra table__heading--attendees">Attendees</th>
        </thead>
        <tbody>
          <tr v-for="(ticket, index) in ticketHistory" :key="index" class="table__row">
            <td class="table__cell table__cell--date">{{ ticket.date | moment('DD MMMM YYYY') }}</td>
            <td class="table__cell table__cell--extra table__cell--center">{{ ticket.date | moment('HH:mm') }}</td>
            <td class="table__cell table__cell--extra table__cell--center">{{ ticket.att_date | moment('HH:mm')  }}</td>
            <td class="table__cell">{{ ticket.name }}</td>
            <td class="table__cell table__cell--extra table__cell--attendees">{{ ticket.number_attendances }}</td>
          </tr>
        </tbody>
      </table>

    </section>

    <section class="wide-section">
      <h2 class="heading-2 align-left">Loyalty</h2>

      <div class="teamcard-summary">
        <div class="teamcard-summary__left-col">
          <p class="teamcard-summary__max">&nbsp;</p>
        </div>

        <div class="teamcard-summary__right-col">
          <p class="teamcard-summary__balance">Balance: <span class="teamcard-summary__balance-total">{{ teamCardBalance }}</span></p>
          <p class="teamcard-summary__balance">Pending: <span class="teamcard-summary__balance-pending">{{ pendingBalance }}</span></p>
        </div>
      </div>

      <table class="table">
        <thead>
          <th class="table__heading table__heading--action">Action</th>
          <th class="table__heading table__heading--date">Date</th>
          <th class="table__heading table__heading--extra">Time</th>
          <th class="table__heading table__heading--extra">Origin of Spend</th>
          <th class="table__heading table__heading--points">Points</th>
        </thead>
        <tbody>
          <tr v-for="(transaction, index) in loyaltyTransactions" :key="index" class="table__row">
            <td class="table__cell" :class="createIconClass(transaction.txn_type_desc)">{{ transaction.txn_type_desc }}</td>
            <td class="table__cell table__cell--date">{{ transaction.txn_timestamp | moment('DD MMMM YYYY') }}</td>
            <td class="table__cell table__cell--extra">{{ transaction.txn_timestamp | moment('HH:mm') }}</td>
            <td class="table__cell table__cell--extra">{{ transaction.txn_partner }}</td>
            <td class="table__cell table__cell--points"
              :class="{ 'table__cell--minus': transaction.txn_inout==='out' | transaction.txn_inout==='special' }">
              <span v-if="transaction.txn_inout=='in'">+</span>{{ transaction.txn_points }}
            </td>
          </tr>
        </tbody>
      </table>

    </section>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UserProfileMembership',

  components: {
    //
  },

  data () {
    return {
      ticketHistory: null,
      firstName: null,
      lastName: null,
      clientRefNo: null,
      showTeamCard: false,
      teamCardBalance: 0,
      maxReward: 0,
      pendingBalance: 0,
      loyaltyTransactions: null,
      nextGame: null
    }
  },
  created () {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {
      this.firstName = userData.given_name
      this.lastName = userData.family_name
      this.clientRefNo = userData['custom:client_ref_no']
      if(this.clientRefNo){
        
        var vm = this 
        //get latest names for validation checks
        this.$getCurrentUserAttributes().subscribe((userData) => {
          
          this.$getSession().subscribe((sessionData) => {
            
            const httpOptions = {
              headers:{
                'Content-Type':  'application/json',
                'Authorization': String(sessionData.idToken.jwtToken)
              }
            }
            
            // Get Teamcard Data
            axios.get(`${process.env.VUE_APP_TEAMCARD_API}/validate?firstName=${vm.firstName}&lastName=${vm.lastName}&clientRefNo=${this.clientRefNo}`, httpOptions ).then(function (teamCardResponse) {
              if (teamCardResponse.data.valid === true) {
                console.log('teamCardResponse:', teamCardResponse.data)
                vm.showTeamCard = true
                vm.teamCardBalance = teamCardResponse.data.balance
                vm.maxReward = teamCardResponse.data.maxReward

              } 
            }).catch(function (error) {
            })

            // Get recent teamcard transactions
            axios.get(`${process.env.VUE_APP_TEAMCARD_API}/transactions?firstName=${vm.firstName}&lastName=${vm.lastName}&clientRefNo=${this.clientRefNo}`, httpOptions ).then(function (teamCardTransactions) {
              if (teamCardTransactions) {
                console.log('teamCardTransactions:', teamCardTransactions.data)
                vm.loyaltyTransactions = teamCardTransactions.data.transactions

              } 
            }).catch(function (error) {
            })

            // Get ticket summary infomration (including next game)
            axios.get(`${process.env.VUE_APP_TEAMCARD_API}/summary?firstName=${vm.firstName}&lastName=${vm.lastName}&clientRefNo=${this.clientRefNo}`, httpOptions ).then(function (teamCardSummary) {
              if (teamCardSummary) {
                console.log('teamCardSummary:', teamCardSummary.data)
                if (teamCardSummary.data.next_entitlement) {
                  vm.nextGame = teamCardSummary.data.next_entitlement
                }

                vm.pendingBalance = teamCardSummary.data.pending_balance
              } 
            }).catch(function (error) {
            })

            // Get recent attendance infomration
            axios.get(`${process.env.VUE_APP_TEAMCARD_API}/attendance?firstName=${vm.firstName}&lastName=${vm.lastName}&clientRefNo=${this.clientRefNo}`, httpOptions ).then(function (teamCardAttendance) {
              if (teamCardAttendance) {
                console.log(teamCardAttendance.data)
                vm.ticketHistory = teamCardAttendance.data.events

              } 
            }).catch(function (error) {
            })

            

          }), 
          (err)=> {
              console.log('Unable get user session.')
          }
        }, 
        (err)=> {
          console.log('Unable to load user profile, session may not be present.')
        });
      } 
    });
  },

  methods: {
    createIconClass(type) {
      return `icon-${type.toLowerCase().replace(/\s/g, '-')}`;
    }
  }

}
</script>

<style lang="scss" scoped>
  .membership {
    margin: 65px auto;
    max-width: 1080px;
  }

  .columns {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0 0 40px;
  }

  .team-card-help {
    margin: 0 16px 0;
  }

  .column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 20px 40px;
    width: 100%;

    @media screen and (min-width: 540px) {
      width: 500px;
    }
  }

  .wide-section {
    margin: 0 20px 100px;
  }

  .section-subheading {
    padding: 0;
    margin: 0 0 27px;
    color: #231F20;
    font-size: 20px;
    font-weight: 400;
    text-align: left;
  }

  .section-link {
    margin: 35px 0 0;
    color: #D7172F;
    font-size: 18px;
    align-self: flex-end;

    &:hover {
      text-decoration: none;
    }
  }

  .card {
    // Flexible card sizing: change the card font size to scale
    font-size: 6px;
    height: 26.8em;
    width: 50em;
    padding: 3.08em 3.9em 2.2em;

    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #FFF;
    border: 1px solid #DEDEDE;
    border-radius: 12px;
    box-shadow: 0 5px 4px 0 #DEDEDE;

    @media screen and (min-width: 540px) {
      font-size: 10px;
    }

    &__header {
      width: 100%;
    }

    &__footer {
      width: 100%;
    }
  }

  .season-card {
    color: #fff;
    background: linear-gradient(158.99deg, #D7172F 0%, #820609 100%);

    &:after {
      content: '';
      position: absolute;
      bottom: 2em;
      right: 2em;
      height: 8em;
      width: 6em;
      background: transparent url('../assets/stoke-logo-white.png') 50% 50% no-repeat;
      background-size: 100%;
      z-index: 2;
    }

    &__heading {
      font-size: 4.39em;
      font-weight: 400;
      line-height: 1.2em;
      text-transform: uppercase;
      word-spacing: -0.2em;

      span {
        font-weight: 500;
      }
    }

    &__subheading {
      padding: 0;
      margin: 0;
      font-size: 2.64em;
      font-weight: 400;
      line-height: 1.2em;
      text-transform: uppercase;
      word-spacing: -0.2em;

      span {
        font-weight: 500;
      }
    }
  }

  .season-pass-container {
    margin: 80px 0 0;
    width: 100%;
  }

  .season-pass {
    &:after {
      content: '';
      position: absolute;
      top: 2.5em;
      right: 3.2em;
      height: 6em;
      width: 6em;
      background: transparent url('../assets/audio.png') 50% 50% no-repeat;
      background-size: 100%;
      z-index: 2;
    }

    &__heading {
      font-size: 2.64em;
      font-weight: 500;
      line-height: 1.2em;
      text-transform: uppercase;
    }

    &__subheading {
      padding: 0;
      margin: 0.5em 0 1em;
      font-size: 2.64em;
      font-weight: 500;
      line-height: 1.2em;
      text-transform: uppercase;

      span {
        font-weight: 400;
      }
    }

    &__desc {
      margin: 0;
      padding: 0;
      font-size: 12px;

      @media screen and (min-width: 540px) {
        font-size: 15px;
      }

    }
  }

  .teamcard-summary {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin: 40px 0 20px;
    padding: 35px 0 25px;
    border-top: 1px solid #979797;
    border-bottom: 1px solid #979797;

    &__left-col {
      position: relative;
      padding: 30px 0 0;

      &:before {
        content: '';
        font-size: 6px;
        position: absolute;
        top: -15px;
        left: 0;
        height: 5.2em;
        width: 20.4em;
        background: transparent url('../assets/teamcard_logo@2x.png') 50% 50% no-repeat;
        background-size: 100%;
        z-index: 2;
      }
    }

    &__max {
      padding: 0;
      margin: 0;
      font-size: 16px;
    }

    &__balance {
      padding: 0;
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      text-align: right;

      &:first-child {
        padding-bottom: 10px;
      }
    }

    &__balance-total {
      display: inline-block;
      min-width: 40px;
      color: #d7172f;
    }

    &__balance-pending {
      display: inline-block;
      min-width: 40px;
      color: #878787;
    }
  }

  .teamcard {
    color: #231F20;

    &:after {
      content: '';
      position: absolute;
      bottom: 3.4em;
      right: 1.8em;
      height: 5.2em;
      width: 20.4em;
      background: transparent url('../assets/teamcard_logo@2x.png') 50% 50% no-repeat;
      background-size: 100%;
      z-index: 2;
    }

    &__heading {
      font-size: 2.64em;
      font-weight: 400;
      line-height: 1.2em;
      text-transform: uppercase;
      word-spacing: -0.2em;

      span {
        font-weight: 500;
      }
    }

    &__points {
      margin: 0.15em 0 0;
      font-size: 3.51em;
      font-weight: 500;
      line-height: 1.2em;
    }
  }

  .table {
    padding: 20px 0 0;
    width: 100%;

    &__heading {
      padding: 0 20px 10px 0;
      font-size: 16px;
      font-weight: 500;
      text-align: left;

      @media screen and (min-width: 1000px) {
        font-size: 20px;
      }

      &--stretch {
        width: 100%;
      }

      &--extra {
        display: none;

        @media screen and (min-width: 800px) {
          display: table-cell;
        }
      }

      &--center {
        text-align: center;
      }

      &--attendees {
        padding-right: 0;
        text-align: center;
      }

      &--points {
        padding-right: 0;
        text-align: right;
      }
    }

    &__cell {
      padding: 25px 20px 25px 0;
      font-size: 13px;
      text-align: left;
      border-bottom: 1px solid #eee;

      @media screen and (min-width: 1000px) {
        font-size: 15px;
      }

      &--center {
        text-align: center;
      }

      &--stretch {
        width: 100%;
      }

      &--extra {
        display: none;

        @media screen and (min-width: 800px) {
          display: table-cell;
        }
      }

      &--attendees {
        padding-right: 0;
        text-align: center;
      }

      &--points {
        padding-right: 0;
        text-align: right;
      }

      &--minus {
        color: #d7172f;
      }

      &--date {
        width: 140px;

        @media screen and (min-width: 1000px) {
          width: 180px;
        }
      }
    }
  }

  .icon-award {
    padding-left: 40px;
    background: transparent url('../assets/award-447088.png') center left no-repeat;
    background-size: 24px 32px;
  }

  .icon-expire-points {
    padding-left: 40px;
    background: transparent url('../assets/last-minute-148874.png') center left no-repeat;
    background-size: 32px 29px;
  }

  .icon-redeem {
    padding-left: 40px;
    background: transparent url('../assets/swipe-1534338.png') center left no-repeat;
    background-size: 32px 28px;
  }

  .next-ticket {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin: 40px 0;
    padding: 0 0 0 85px;
    width: 100%;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 70px;
      width: 70px;
      background: #eee url('../assets/ticket-icon.png') 50% 50% no-repeat;
      background-size: 60%;
      border-radius: 50%;
    }

    &__info {
      padding: 0 40px 0 0;
      margin: 0;
      width: 100%;
    }

    &__time {
      display: block;
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-weight: 500;
    }

    &__date {
      display: block;
      font-size: 16px;
      font-weight: 400;
    }

    &__main {
      flex-grow: 1;
      padding: 0;
      margin: 10px 0;
      width: 100%;
      font-size: 20px;
      font-weight: 500;
    }

    &__buy {
      display: block;
      margin: 10px 0 0;
      padding: 9px 12px 11px;
      color: #fff;
      text-align: center;
      text-decoration: none;
      white-space: nowrap;
      background-color: #d7172f;
    }
  }

  @media screen and (min-width: 800px) {
    .next-ticket {
      flex-wrap: nowrap;

      &:before {
        top: 50%;
        transform: translateY(-50%);
      }
      &__info {
        width: auto;
      }
      &__main {
        flex-grow: 1;
        margin: 0;
        width: auto;
        font-size: 25px;
      }
      &__time {
        font-size: 20px;
      }
      &__buy {
        margin: 0 0 0 30px;
      }
    }
  }
</style>
